import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators.js';

@customElement('cds-text-overflow')
export class TextOverflowElement extends LitElement {
  static styles = css`
    :host {
      display: inline-block;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  `;

  private _mouseEnterHandler = () => {
    this._updateTitle();
  };

  private _updateTitle() {
    const text = this.textContent || '';
    if (this.scrollWidth > this.offsetWidth) {
      this.setAttribute('title', text);
    } else {
      this.removeAttribute('title');
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('mouseenter', this._mouseEnterHandler);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('mouseenter', this._mouseEnterHandler);
  }

  render() {
    return html`<slot></slot>`;
  }
}